<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{headerTitle}}</span>
  </div>
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content" *ngIf="!typeLoading">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Type:</div>

      <div class="email-input-text">
        <p-dropdown [ngModelOptions]="{standalone: true}"
                    [options]="allTypes"
                    [(ngModel)]="selectedType"
                    optionLabel="title"
                    defaultLabel="Type"
                    [required]="true" (onChange)="subTypeChanged()" [disabled]="!!tempNfsSub?.id">
        </p-dropdown>
      </div>
    </div>
    <div class="input-block" *ngIf="selectedType?.value === 'SPECIAL_USER' || selectedType?.value === 'USER_ROLE'">
      <div class="input-label">Subs:</div>

      <div class="email-input-text" *ngIf="selectedType?.value === listOfSubs[0]">
        <p-dropdown [ngModelOptions]="{standalone: true}"
                    [options]="allUsers"
                    [(ngModel)]="selectedUser"
                    optionLabel="name"
                    defaultLabel="User">
        </p-dropdown>
      </div>
      <div class="email-input-text" *ngIf="selectedType?.value === listOfSubs[1]">
        <p-dropdown [ngModelOptions]="{standalone: true}"
                    [options]="allRoles"
                    [(ngModel)]="selectedRole"
                    optionLabel="name"
                    defaultLabel="Role">
        </p-dropdown>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Send SMS:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempNfsSub.sendSMS">
        </p-inputSwitch>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Send Email:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempNfsSub.sendEmail">
        </p-inputSwitch>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Show in System:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempNfsSub.showInSystem">
        </p-inputSwitch>
      </div>
    </div>
  </div>

  <div class="save-btn-block">
    <div class="sav-btn-bloock">
      <div class="space-block">
      </div>

      <button mat-button class="save-btn" (click)="saveSub()" [disabled]="loadingSpinner"
              tabindex="1" type="submit" [ngClass]="{'disabled-button': loadingSpinner}">

        <span *ngIf="!loadingSpinner">{{footerBtnString}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="footerBtnString === 'Save'" mat-button class="delete-task-button" (click)="deleteSub()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>

    </div>
  </div>
</div>
<div class="loading-spinner-block" *ngIf="typeLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
